import { useSyncExternalStore } from "react";

type PanelState = { isOpen: boolean };

let state: PanelState = { isOpen: false };
const listeners = new Set<() => void>();

function notify() {
  listeners.forEach((l) => l());
}

export function openCaptain() {
  state = { isOpen: true };
  notify();
}

export function closeCaptain() {
  state = { isOpen: false };
  notify();
}

export function toggleCaptain() {
  state = { isOpen: !state.isOpen };
  notify();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return state;
}

export function useCaptainPanel() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
